import apiClient from '../api'

const AUTH_TOKEN_KEY = 'nitwit_auth_token'
const AUTH_PLAYER_KEY = 'nitwit_player'

export const authService = {
    // Get stored token
    getToken() {
        return localStorage.getItem(AUTH_TOKEN_KEY)
    },

    // Get stored player info
    getPlayer() {
        const data = localStorage.getItem(AUTH_PLAYER_KEY)
        return data ? JSON.parse(data) : null
    },

    // Check if user is authenticated
    isAuthenticated() {
        return !!this.getToken()
    },

    // Store auth data after successful login/registration
    setAuth(token, player) {
        localStorage.setItem(AUTH_TOKEN_KEY, token)
        localStorage.setItem(AUTH_PLAYER_KEY, JSON.stringify(player))
    },

    // Clear auth data
    clearAuth() {
        localStorage.removeItem(AUTH_TOKEN_KEY)
        localStorage.removeItem(AUTH_PLAYER_KEY)
    },

    // API: Check if player name is claimed
    async checkName(name) {
        const response = await apiClient.get('/auth/check_name/', {
            params: {name}
        })
        return response.data
    },

    // API: Request OTC
    async requestCode(email, purpose, playerName = '') {
        const response = await apiClient.post('/auth/request_code/', {
            email,
            purpose,
            player_name: playerName,
        })
        return response.data
    },

    // API: Verify OTC
    async verifyCode(email, code) {
        const response = await apiClient.post('/auth/verify_code/', {
            email,
            code,
        })
        const {token, player, claimed_sessions} = response.data
        this.setAuth(token, player)
        return {player, claimed_sessions}
    },

    // API: Logout
    async logout() {
        try {
            await apiClient.post('/auth/logout/')
        } finally {
            this.clearAuth()
        }
    },

    // API: Get current user
    async getCurrentUser() {
        const response = await apiClient.get('/auth/me/')
        return response.data
    },
}
